import * as React from 'react'
import {connect} from "react-redux";
import {ActionType, CHAINTYPES, merchantInfoType, ApplyInfoType, CurrencyInfoType, accountInfoType, DetailInfoType, reducerStoreType} from "../../reducers/types";
import {Dispatch} from "redux";
import {injectIntl, IntlShape} from "react-intl";
import Select from '@material-ui/core/Select';
import {MyInput, MyMenuItem} from "../../components/CustomUIComp/CustomFormElem";

interface IProps {
    dispatch: Dispatch<ActionType<any>>,
    chainType: CHAINTYPES,
	merchantInfo: merchantInfoType,
	intl: IntlShape,
	applyInfo: ApplyInfoType,
	currencyList: CurrencyInfoType[],
	accountInfo: accountInfoType,
	detailInfo: DetailInfoType
}

class ApplyForm extends React.Component<IProps, {}> {
	
	handleBankChange = (useDefaultBankInfo: any) => {
	    this.props.dispatch({type: 'BANK_CHANGE', payload: useDefaultBankInfo})
	}
	
	handleAmtChange = (sellAmt: any) => {
	    this.props.dispatch({type: 'AMT_CHANGE', payload: sellAmt})
	}
	
	handleCurrencyChange = (buyCurrency: any) => {
	    this.props.dispatch({type: 'CURRENCY_CHANGE', payload: buyCurrency})
	}
	
	handleBankName = (bankName: any) => {
		this.props.dispatch({type: 'SET_BANK_NAME', payload: bankName})
	}
	
	handleAccountNo = (bankAccountNo: any) => {
		this.props.dispatch({type: 'SET_BANK_ACCOUNTNO', payload: bankAccountNo})
	}
	
	handleAccountName = (bankAccountName: any) => {
		this.props.dispatch({type: 'SET_BANK_ACCOUNTNAME', payload: bankAccountName})
	}
	
	handleAddress = (bankAddress: any) => {
		this.props.dispatch({type: 'SET_BANK_ADDRESS', payload: bankAddress})
	}
	
	handleCode = (swiftcode: any) => {
		this.props.dispatch({type: 'SET_BANK_SWIFTCODE', payload: swiftcode})
	}
	
	handleConfirm = () => {
		this.props.dispatch({type: 'SUBMIT_EXCHANGE',payload:{}})
	}
	
	getDefaultBank = () => {
	    let {intl} = this.props
	    return [
	        {value: 1, label: intl.formatMessage({id: 'yes'})},
	        {value: 0, label: intl.formatMessage({id: 'no'})}
	    ]
	}
	
    public render() {
		const setBank = this.getDefaultBank()
        let {applyInfo,intl,currencyList,accountInfo,detailInfo,merchantInfo} = this.props
        return (
                <div className="applyForm">
                    <div className="header">
                        <h2>{intl.formatMessage({id: 'exchangeApply'})}</h2>
					</div>
					<div className="applycontent">
						<div className="container">
							<div className="applyInfo">
								<p className="infolabel">{intl.formatMessage({id: 'canExchangeAmount'})}:</p>
								<p className="infocontent">{accountInfo.canWithdrawAmt}({merchantInfo.orgCurrency})</p>
							</div>
							<div className="applyInfo">
								<p className="infolabel">{intl.formatMessage({id: 'salesAmount'})}:</p>
								<input 
									className="infocontent" 
									type="number" 
									value={applyInfo.sellAmt}
									onChange={
										(event: React.ChangeEvent<{ name?: string; value: any }>) => this.handleAmtChange({
											sellAmt: event.target.value
										})
									}
								/>
							</div>
							<div className="applyInfo">
								<p className="infolabel">{intl.formatMessage({id: 'buyingCurrency'})}:</p>
								<Select
									value={applyInfo.buyCurrency}
									onChange={
										(event: React.ChangeEvent<{ name?: string; value: any }>) => this.handleCurrencyChange({
											buyCurrency: event.target.value
										})
									}
									input={<MyInput className="select" height={14} labelmargin={18} id="settle-status-select" name="setcurrency"/>}
								>
									{
										currencyList.map((item, i) => {
											return <MyMenuItem key={`settle-statues-${item.currency}`}
															   value={item.currency}>{item.currency}(1{merchantInfo.orgCurrency}={item.exchangeRate}{item.currency})</MyMenuItem>
										})
									}
								</Select>
							</div>
							<div className="applyInfo">
								<p className="infolabel">{intl.formatMessage({id: 'purchaseAmount'})}:</p>
								<input
									className="infocontent"
									value={detailInfo.purchaseAmount}
									disabled
								/>
							</div>
							<div className="applyInfo">
								<p className="infolabel">{intl.formatMessage({id: 'defaultBank'})}:</p>
								<Select
									value={applyInfo.useDefaultBankInfo}
									onChange={
										(event: React.ChangeEvent<{ name?: string; value: any }>) => this.handleBankChange({
											useDefaultBankInfo: event.target.value
										})
									}
									input={<MyInput className="select" height={14} labelmargin={18} id="settle-status-select" name="setbank"/>}
								>
									{
										setBank.map((item, i) => {
											return <MyMenuItem key={`settle-statues-${item.value}`}
															   value={item.value}>{item.label}</MyMenuItem>
										})
									}
								</Select>
							</div>
						</div>
						<div className="bankInfo">
							{
								applyInfo.useDefaultBankInfo === 0 ? <div className="applyInfo"><p className="infolabel">{intl.formatMessage({id: 'bankName'})}:</p>
								<input 
									className="infocontent" 
									value={applyInfo.bankName}
									onChange={
										(event: React.ChangeEvent<{ name?: string; value: any }>) => this.handleBankName({
											bankName: event.target.value
										})
									} 
								/></div> : null
							}
							{
								applyInfo.useDefaultBankInfo === 0 ? <div className="applyInfo"><p className="infolabel">{intl.formatMessage({id: 'bankNumber'})}:</p>
								<input 
									className="infocontent"
									value={applyInfo.bankAccountNo}
									onChange={
										(event: React.ChangeEvent<{ name?: string; value: any }>) => this.handleAccountNo({
											bankAccountNo: event.target.value
										})
									}
								/></div> : null
							}
							{
								applyInfo.useDefaultBankInfo === 0 ? <div className="applyInfo"><p className="infolabel">{intl.formatMessage({id: 'bankAccName'})}:</p>
								<input 
									className="infocontent"
									value={applyInfo.bankAccountName}
									onChange={
										(event: React.ChangeEvent<{ name?: string; value: any }>) => this.handleAccountName({
											bankAccountName: event.target.value
										})
									}
								/></div> : null
							}
							{
								applyInfo.useDefaultBankInfo === 0 ? <div className="applyInfo"><p className="infolabel">{intl.formatMessage({id: 'bankAddress'})}:</p>
								<input 
									className="infocontent"
									value={applyInfo.bankAddress}
									onChange={
										(event: React.ChangeEvent<{ name?: string; value: any }>) => this.handleAddress({
											bankAddress: event.target.value
										})
									}
								/></div> : null
							}
							{
								applyInfo.useDefaultBankInfo === 0 ? <div className="applyInfo"><p className="infolabel">{intl.formatMessage({id: 'swiftcode'})}:</p>
								<input 
									className="infocontent"
									value={applyInfo.swiftcode}
									onChange={
										(event: React.ChangeEvent<{ name?: string; value: any }>) => this.handleCode({
											swiftcode: event.target.value
										})
									}
								/></div> : null
							}
						</div>
						<button className="primaryButton" onClick={this.handleConfirm}>{intl.formatMessage({id: 'confirm'})}</button>
					</div>
				</div>
        );
    }
}

export default injectIntl(connect((state: reducerStoreType, props) => {
    return {
        merchantInfo: state.merchant.merchantInfo,
		chainType: state.merchant.merchantInfo.chainType,
		applyInfo: state.exchangeApply.ApplyInfo,
		currencyList: state.exchangeApply.CurrencyList.list,
		accountInfo: state.account.accountInfo,
		detailInfo: state.exchangeApply.DetailInfo
    }
})(ApplyForm))